import { render, staticRenderFns } from "./EventsCalendarView.vue?vue&type=template&id=6dccba19&"
import script from "./EventsCalendarView.vue?vue&type=script&lang=js&"
export * from "./EventsCalendarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports